import React from "react";

interface RoutePagerProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

// Compact "‹ N / M ›" pager pill used under the route search results.
const RoutePager: React.FC<RoutePagerProps> = ({
  page,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  return (
    // Sticky (not fixed): pins to the bottom of the scroll area while there are
    // results below, then settles into flow above the footer at the very end —
    // so it never covers the footer. A bottom fade keeps cards readable as they
    // scroll behind the pill.
    <div className="sticky bottom-0 z-40 flex justify-center px-4 pt-8 pb-4 bg-gradient-to-t from-[#f1f3f6] via-[#f1f3f6]/90 to-transparent pointer-events-none">
      <div className="pointer-events-auto inline-flex items-center bg-[#1F2937] rounded-full px-1 py-1 gap-1 shadow-lg">
        <button
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page === 1}
          className="w-8 h-8 flex items-center justify-center rounded-full text-white hover:bg-white/10 transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <span className="text-white text-sm font-medium px-3">
          {page} / {totalPages}
        </span>
        <button
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page === totalPages}
          className="w-8 h-8 flex items-center justify-center rounded-full text-white hover:bg-white/10 transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default RoutePager;
